import * as _ from 'lodash';
import { WarningMessageType } from './vehicle-warning';

export class VehicleWarningConfig {
    public static warningsWithOwnCategories = [
        WarningMessageType.ImmobilizerBypass,
        WarningMessageType.SocWarning,
        WarningMessageType.VehicleDelay,
        WarningMessageType.NoParkingSpotFound,
        WarningMessageType.TripNotStartedWarning,
        WarningMessageType.OffRouteWarning,
        WarningMessageType.SignOnMissingWarning
    ];

    public static confirmableWarnings = [
        WarningMessageType.TripNotStartedWarning,
        WarningMessageType.ImmobilizerBypass,
        WarningMessageType.SignOnMissingWarning
    ];

    public static warningsThatCanBeToggledInSettings = [
        WarningMessageType.SocWarning, WarningMessageType.NoParkingSpotFound,
        WarningMessageType.VehicleDelay, WarningMessageType.ImmobilizerBypass,
        WarningMessageType.TripNotStartedWarning, WarningMessageType.OffRouteWarning,
        WarningMessageType.SignOnMissingWarning
    ];

    private _visibleWarnings: WarningMessageType[] = [];

    constructor(obj = null) {
        if (obj) {
            // The WarningMessageType ChargingWarning (4) was removed in #56956 at 2024-04-29.
            // Stored app states might still have it which would result in a "Other warnings"
            // category if not removed. This code removes it. After sufficient time has passed
            // this code can be removed.
            const index = obj._visibleWarnings.indexOf(4, 0);
            if (index > -1) {
                obj._visibleWarnings.splice(index, 1);
            }
            Object.assign(this, obj);
        } else {
            // adds these warnings by default
            this._visibleWarnings = [
                WarningMessageType.ImmobilizerBypass,
                WarningMessageType.SocWarning,
                WarningMessageType.VehicleDelay,
                WarningMessageType.NoParkingSpotFound,
                WarningMessageType.TripNotStartedWarning,
                WarningMessageType.OffRouteWarning,
                WarningMessageType.Other
            ];
        }
    }

    public toggle(type: WarningMessageType): void {
        if (this.isVisible(type)) {
            _.remove(this._visibleWarnings, warning => warning === type);
        } else {
            this._visibleWarnings.push(type);
        }
    }

    public isVisible(type: WarningMessageType): boolean {
        return _.indexOf(this._visibleWarnings, type) > -1;
    }

    public getWarningsOrder(): WarningMessageType[] {
        return this._visibleWarnings;
    }

    public setWarningsOrder(newWarningOrder: WarningMessageType[]) {
        this._visibleWarnings = newWarningOrder;
    }
}
